var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("欢迎进入")]),_c('div',[_vm._v("中南民族大学学生宿舍预付费系统")])])}]

export { render, staticRenderFns }